var _style, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBjerkingBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 516 270",
    style: {
      enableBackground: "new 0 0 516 270"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D2CECC;}\n\t.st1{opacity:0.1;}\n\t.st2{fill:#F0ECEA;}\n\t.st3{fill:#8C8886;}\n\t.st4{fill:#504C4A;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 516,
    height: 270
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 516,
    height: 270
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474,
    y: 44,
    className: "st2",
    width: 18,
    height: 116
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 121,
    className: "st2",
    width: 24,
    height: 116
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 132,
    className: "st2",
    width: 12,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 55,
    className: "st2",
    width: 24,
    height: 116
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 198,
    className: "st2",
    width: 12,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 110,
    className: "st2",
    width: 24,
    height: 138
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 99,
    className: "st0",
    width: 30,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 110,
    className: "st0",
    width: 18,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 110,
    className: "st0",
    width: 24,
    height: 138
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 99,
    className: "st0",
    width: 30,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 66,
    className: "st0",
    width: 12,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 121,
    className: "st0",
    width: 18,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 132,
    className: "st0",
    width: 12,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 0,
    className: "st3",
    width: 24,
    height: 116
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 220,
    className: "st3",
    width: 12,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 88,
    className: "st3",
    width: 18,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 33,
    className: "st3",
    width: 24,
    height: 116
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 66,
    className: "st3",
    width: 18,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492,
    y: 88,
    className: "st4",
    width: 24,
    height: 116
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 77,
    className: "st4",
    width: 12,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 143,
    className: "st4",
    width: 18,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 66,
    className: "st4",
    width: 24,
    height: 116
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 22,
    className: "st4",
    width: 18,
    height: 116
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 110,
    className: "st4",
    width: 24,
    height: 116
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 99,
    className: "st4",
    width: 18,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    y: 77,
    className: "st4",
    width: 24,
    height: 116
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBjerkingBg);
export default __webpack_public_path__ + "static/media/bjerking_bg.3ec54dca50376d360d1a5fadf6619f7d.svg";
export { ForwardRef as ReactComponent };